import React from "react";
import { ImagePicker } from "./ImagePicker";
import { PaziaModal } from "components/molecules";

interface CropImageModalProps {
  onCloseRequest: () => void;
  onConfirm: (image: File, blobUrl: string) => void;
  imageSrc: string | null;
  isOpen: boolean;
}

export const CropImageModal = ({ onCloseRequest, isOpen, onConfirm, imageSrc }: CropImageModalProps) => {
  return (
    <PaziaModal
      id="crop-image-modal"
      onCloseRequest={onCloseRequest}
      isOpen={isOpen}
      size="3xl"
      style={{ height: "50%" }}
    >
      {imageSrc && (
        <div className="h-3/4 w-full">
          <ImagePicker defaultImage={imageSrc} onConfirm={onConfirm} />
        </div>
      )}
    </PaziaModal>
  );
};
